import React, { useEffect, useState } from 'react';
import { Icon } from '@/presentation/reusables/components/Icon';
import {
  SValidationResult,
  SValidationResultBody,
  SValidationResultItem,
  SValidationResultList
} from './styled';
import IDHelpers from '@/core/helpers/IDHelper';
import { ErrorMessage } from '../ErrorMessage';
import { Tooltip } from '@/presentation/reusables/components/Tooltip';

type ValidationResultProps = {
  result?: any[];
  setIsValid: (isValid: boolean) => void;
};

export const ValidationResult = ({
  result,
  setIsValid
}: ValidationResultProps) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const [states, setStates] = useState([
    {
      id: 'height',
      isValid: true,
      name: 'Altura',
      tooltip: 'Debes cumplir el alto de foto requerida: **288px**.'
    },
    {
      id: 'width',
      isValid: true,
      name: 'Ancho',
      tooltip: 'Debes cumplir el ancho de foto requerida: **240px**.'
    },
    {
      id: 'resolution',
      isValid: false,
      name: 'Resolución',
      tooltip: 'Debes cumplir la resolución de foto requerida: **300 dpi**.'
    },
    {
      id: 'background',
      isValid: true,
      name: 'Color de fondo',
      tooltip: 'Debes cumplir el color de fondo requerido: **Blanco**.'
    },
    {
      id: 'position',
      isValid: true,
      name: 'Posición del rostro',
      tooltip: 'Debes cumplir la posición del rostro requerida: **Frente**.'
    }
  ]);

  useEffect(() => {
    if (result) {
      result.forEach((item) => {
        setStates((prev) =>
          prev.map((state) => {
            if (state.id === item.id) {
              return { ...state, isValid: item.isValid };
            }
            return state;
          })
        );
      });

      const isValid = result.every((item) => item.isValid);

      if (isValid) {
        setIsValid(true);
        setErrorMessage(undefined);
      } else {
        setIsValid(false);
        setErrorMessage(
          '¡Ups! Tu foto no superó la validación. Cambia de archivo y vuelve a intentarlo.'
        );
      }
    }
  }, [result]);

  return (
    <SValidationResult>
      <SValidationResultBody>
        <p>Resultados de validación:</p>
        <SValidationResultList>
          {states.map((state) => (
            <SValidationResultItem
              isValid={state.isValid}
              key={IDHelpers.generateID()}
            >
              <Icon name={state.isValid ? 'check' : 'close'} />
              <p>{state.name}.</p>
              {!state.isValid && <Tooltip text={state.tooltip} />}
            </SValidationResultItem>
          ))}
        </SValidationResultList>
      </SValidationResultBody>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </SValidationResult>
  );
};
